import React from "react";

export function PageHeader({ eyebrow, title, subtitle, right }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#FF5722] mb-2">{eyebrow}</div>
        )}
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-sm text-slate-400 mt-2">{subtitle}</p>}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}

export function Card({ children, className = "", testid, ...rest }) {
  return (
    <div
      data-testid={testid}
      className={`bg-[#13151A] border border-white/10 rounded-sm relative ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function Stat({ label, value, hint, testid }) {
  return (
    <Card className="p-5 relative" testid={testid}>
      <span className="absolute top-0 left-0 w-2 h-[2px] bg-[#FF5722]" />
      <span className="absolute top-0 left-0 h-2 w-[2px] bg-[#FF5722]" />
      <div className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-3">{label}</div>
      <div className="mono text-3xl font-medium text-white">{value ?? "—"}</div>
      {hint && <div className="text-xs text-slate-500 mt-2">{hint}</div>}
    </Card>
  );
}

export function EmptyState({ title, hint, testid }) {
  return (
    <div className="border border-dashed border-white/10 py-16 flex flex-col items-center justify-center text-center" data-testid={testid}>
      <div className="mono text-[10px] uppercase tracking-[0.25em] text-slate-500">No data</div>
      <div className="text-lg font-medium mt-2 text-white">{title}</div>
      {hint && <div className="text-sm text-slate-400 mt-1 max-w-md">{hint}</div>}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2 block">{label}</label>
      {children}
    </div>
  );
}
